import React from "react";

const UserWidgets = () => {
  return (
    <div class="container mt-4">
      <section class="content container-fluid mt-4">
        <div class="row">
          <h4>Welcome to Trinity Highschool Dashboard</h4>
        </div>
      </section>
    </div>
  );
};

export default UserWidgets;
